import { Component } from '@angular/core';
import { AuthService } from '@shared/services/auth/auth.service';
import { LabelType } from '@vr/vr-storybook-lib';

@Component({
  selector: 'cm-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  labelType = LabelType;

  login() {
    this.authService.login();
  }

  constructor(private authService: AuthService) {}
}
